export const setCurrentUser = (state, {currentUser}) => {
  state.currentUser = currentUser
}

export const setDestinyMemberships = (state, {destinyMemberships}) => {
  state.destinyMemberships = destinyMemberships
}

export const setCurrentDestinyMembershipIndex = (state, {index}) => {
  state.currentDestinyMembership = state.destinyMemberships[index]
}

export const setLoading = (state, {loading}) => {
  state.loading = loading
}



// WEBPACK FOOTER //
// ./src/store/destiny/mutations.js